import fetch from 'node-fetch';
function getHttpAgent() {
    const globalOption = {};
    if (typeof window === 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const { Agent: HttpAgent } = require('http');
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const { Agent: HttpAgents } = require('https');
        globalOption.agent = (parsedURL) => {
            return parsedURL.protocol === 'http:' ? new HttpAgent({ keepAlive: true }) : new HttpAgents({ keepAlive: true });
        };
    }
    return globalOption;
}
export const myFetch = async (input, init) => {
    const globalOption = getHttpAgent();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fetch(input, {
        ...globalOption,
        ...init
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    });
};
export { EventEmitter } from 'events';
export { AbortController as LocalAbortController } from 'node-abort-controller';
